import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { clockLabel } from './clockLabel';
import { tiktokMessages } from './tiktokMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the settings sections; each part uses its own slice of it */
import styles from '../settings/PlatformSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TikTokMediaLineProps {
  durationSec: number | null;
  maxDurationSec: number | null;
}

/** The length of the video next to the longest video that the account takes (G2, G7). */
const TikTokMediaLineComponent: React.FC<TikTokMediaLineProps> = ({ durationSec, maxDurationSec }) => {
  const intl = useIntl();
  if (durationSec === null) {
    return null;
  }
  return (
    <div className={styles.media} data-testid="tiktok-media-line">
      <div className={styles.accountText}>
        <span className={styles.eyebrow}>{intl.formatMessage(tiktokMessages.mediaTitle)}</span>
        <span className={styles.small}>
          {maxDurationSec === null
            ? intl.formatMessage(tiktokMessages.mediaLengthOnly, { length: clockLabel(durationSec) })
            : intl.formatMessage(tiktokMessages.mediaLength, {
                length: clockLabel(durationSec),
                max: clockLabel(maxDurationSec),
              })}
        </span>
      </div>
    </div>
  );
};

export const TikTokMediaLine = TypedMemo(TikTokMediaLineComponent);
